var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283 875c-22 0-39-18-39-40 0-20 15-36 34-39h183V652c-86-18-153-91-158-181h-1c-125 0-185-94-176-259 1-19 16-35 34-37h142v-24c0-14 12-26 26-26h344c14 0 26 12 26 26v24h142c18 2 33 18 34 37 9 165-51 259-176 259h-1c-5 90-71 163-158 181v144h191c21 0 39 18 39 39s-15 38-35 40H283zm514-621h-99v138h7c59-3 90-43 92-134v-4zm-495 0h-99v4c2 91 33 131 93 134h6V254z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEvents);
export default __webpack_public_path__ + "static/media/ic_events.31c9614183904c262d8d11117a2cf0aa.svg";
export { ForwardRef as ReactComponent };